var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-top",on:{"click":function($event){$event.preventDefault();return _vm.scrollTop.apply(null, arguments)}}},[_c('div',{staticClass:"arrow"}),_c('div',{staticClass:"bg"}),_c('span',[_vm._v("Scroll to Top")])])}
var staticRenderFns = []

export { render, staticRenderFns }